// extracted by mini-css-extract-plugin
export default {"centered":"UserContext_centered__r-hsr","error":"UserContext_error__8d5bN"};